import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ReduxState } from '../../types/app';

type YandexMetrikaFunction = {
  (...args: unknown[]): void;
  a?: unknown[][];
  l?: number;
};

export const YandexMetrika = () => {
  const yandexMetricId = useSelector(
    (state: ReduxState) => state.Data.config?.yandexMetricId
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !yandexMetricId) {
      return undefined;
    }

    const yandexWindow = window as typeof window & {
      ym?: YandexMetrikaFunction;
    };

    if (!yandexWindow.ym) {
      const ym: YandexMetrikaFunction = (...args) => {
        ym.a = ym.a ?? [];
        ym.a.push(args);
      };

      ym.l = Date.now();
      yandexWindow.ym = ym;
    }

    if (!document.querySelector('script[data-yandex-metrika]')) {
      const script = document.createElement('script');
      script.async = true;
      script.dataset.yandexMetrika = 'true';
      script.src = 'https://mc.yandex.ru/metrika/tag.js';
      document.head.appendChild(script);
    }

    yandexWindow.ym(yandexMetricId, 'init', {
      accurateTrackBounce: true,
      clickmap: true,
      trackLinks: true,
      webvisor: true,
    });

    return () => {
      yandexWindow.ym?.(yandexMetricId, 'destruct');
    };
  }, [yandexMetricId]);

  if (!yandexMetricId) {
    return null;
  }

  return (
    <noscript>
      <div>
        <img
          src={`https://mc.yandex.ru/watch/${yandexMetricId}`}
          style={{ left: '-9999px', position: 'absolute' }}
          alt=""
        />
      </div>
    </noscript>
  );
};
